import { render } from 'datocms-structured-text-to-plain-text'
import { type StructuredText as StructuredTextType } from 'datocms-structured-text-utils'
import React, { type ReactElement } from 'react'
import { Col, Container, Row } from 'react-bootstrap'

import Image from '@/components/image/image'
import StructuredTextDefault from '@/components/structured-text/structured-text-default'

import * as styles from './main-person.module.scss'

const MainPerson = ({
  company,
  linkedin,
  about
}: Readonly<Queries.GctPersonFragment>): ReactElement => {
  const aboutInPlainText = about?.value
    ? render(about as StructuredTextType)
    : null
  return (
    <Container as="section">
      <Row className="py-3 py-lg-5">
        <Col md={3}>
          {company !== null && (
            <Image
              image={company?.logo}
              className={`img-fluid mb-4 ${styles.companyLogo}`}
            />
          )}
        </Col>
        {aboutInPlainText !== null && (
          <Col md={9} className={`ps-lg-5 pb-3 ${styles.aboutColumn}`}>
            <div className={`d-flex align-items-center ${styles.titleAbout}`}>
              <h2>About</h2>

              {linkedin !== null && linkedin !== '' && (
                <>
                  <span>/</span>
                  <a href={linkedin}>
                    <img
                      src="/media/linkedin-author.svg"
                      alt="linkedin profile"
                    />
                  </a>
                </>
              )}
            </div>
            <div className={styles.textAbout}>
              <StructuredTextDefault
                content={about as unknown as StructuredTextType}
              />
            </div>
          </Col>
        )}
      </Row>
    </Container>
  )
}

export default MainPerson
